module.exports = __webpack_public_path__ + "img/goalNotAchievednew.8e524380.png";